import React from 'react';
import SkeletonBlock from './SkeletonBlock';

/**
 * @param {'upcoming' | 'compact'} variant
 */
export default function ListRowSkeleton({ variant = 'upcoming' }) {
  if (variant === 'compact') {
    return (
      <div className="sk-list-row sk-list-row--compact">
        <div className="sk-list-row__body">
          <SkeletonBlock width="46%" height={12} />
          <SkeletonBlock width="68%" height={10} />
        </div>
        <SkeletonBlock variant="pill" width={64} height={20} />
      </div>
    );
  }

  return (
    <div className="sk-list-row">
      <SkeletonBlock className="sk-list-row__accent" width={4} height="100%" />
      <div className="sk-list-row__time">
        <SkeletonBlock width="78%" height={12} />
        <SkeletonBlock width="92%" height={10} />
      </div>
      <div className="sk-list-row__body">
        <div className="sk-list-row__top">
          <SkeletonBlock width="42%" height={13} />
          <SkeletonBlock variant="pill" width={72} height={20} />
        </div>
        <SkeletonBlock width="56%" height={11} />
      </div>
      <SkeletonBlock className="sk-list-row__chevron" width={18} height={18} />
    </div>
  );
}

export function ListRowSkeletonStack({
  rows = 6,
  variant = 'upcoming',
  label = 'Loading',
}) {
  return (
    <div className="sk-host sk-list" role="status" aria-busy="true" aria-label={label}>
      {Array.from({ length: rows }, (_, index) => (
        <ListRowSkeleton key={index} variant={variant} />
      ))}
    </div>
  );
}
